<template>
  
  <div class="recruiter dashboard px-3">
    
    <recruiter-header
    />
    
    <recruiter-job-offers-section
      :job-offers="jobOffersActive"
      :is-loading="isLoading"
      @job-offer-closed="onClosedJobOffer"
    />
   
    <div class="my-3" />
    <recruiter-job-offers-section
      :job-offers="jobOffersClosed"
      :is-loading="isLoading"
      :variant="JOB_OFFERS_STATUSES.CLOSED"
    />
  </div>
</template>

<script>
import Api from '@/providers/Api';
import { JOB_OFFER_STATUSES } from '@/store';
import RecruiterHeader from '@/components/recruiter/RecruiterHeader';
import RecruiterJobOffersSection from '@/components/recruiter/job_offers/RecruiterJobOffersSection';
import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';

const compareActiveJobOffersStatus = (jo) => {
  return jo.status === JOB_OFFER_STATUSES.DRAFT ? 0 : 1;
};

export default {
  name: 'RecruiterDashboard',
  components: {
    RecruiterHeader,
    RecruiterJobOffersSection,
  },
  data: function () {
    return {
      jobOffers: null,
      isLoading: false,
    };
  },
  created: function () {
    this.getData();
  },
  computed: {
    user: function () {
      return this.$store.state.user;
    },
    JOB_OFFERS_STATUSES: function () {
      return JOB_OFFER_STATUSES;
    },
    jobOffersActive: function () {
      return (this.jobOffers || []).filter((jo) => {
        return [
          JOB_OFFER_STATUSES.ACTIVE,
          JOB_OFFER_STATUSES.DRAFT,
          JOB_OFFER_STATUSES.FILLED
        ].includes(jo.status);
      })
        .sort(compareActiveJobOffersStatus);
    },
    jobOffersClosed: function () {
      return (this.jobOffers || []).filter(
        (jo) => jo.status === JOB_OFFER_STATUSES.CLOSED
      );
    },
  },
  methods: {
    getData: async function () {
      this.isLoading = true;
      try {
        this.jobOffers = await Api.getUserJobOffers(this.user.id);
      } catch (e) {
        handleServerErrorWithValidation(e, this.$toasted);
      } finally {
        this.isLoading = false;
      }
    },
    onClosedJobOffer: async function(id) {
      const index = this.jobOffers.findIndex(jo => jo.id === id);
      if (index === -1) return;
      await Api.setJobOfferStatusClosed(this.jobOffers[index].id);
      this.$set(this.jobOffers[index], 'status', JOB_OFFER_STATUSES.CLOSED);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../sass/variables_mixins.scss';

.recruiter {
  font-family: $phairify_font_montserrat;
  margin-top:0px !important;
}
</style>
